import { DatePickerMui, Grid } from "../../../../components";
import { value } from "../../../../helpers";
import { formatDate } from "../../../../utils";

const FormFiltroAvancadoAniversario = ({
  filtrosAvancados,
  setFiltrosAvancados,
}) => {
  const onChangeDate = (name, date) => {
    if (!date) {
      date = "Invalid Date";
    }
    setFiltrosAvancados({
      ...filtrosAvancados,
      [name]: date != "Invalid Date" ? formatDate.toSend(date) : "",
    });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DatePickerMui
            id="dataReferencia"
            name="Data"
            label="Mês"
            margin
            fullWidth
            format="MM"
            views={["month"]}
            value={value.date(filtrosAvancados?.dataReferencia)}
            onChange={(date) => onChangeDate("dataReferencia", date)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormFiltroAvancadoAniversario;
